/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { JSONMap as e } from "../../core/jsonMap.js";
var i = new e({
  esriFieldTypeSmallInteger: "small-integer",
  esriFieldTypeInteger: "integer",
  esriFieldTypeSingle: "single",
  esriFieldTypeDouble: "double",
  esriFieldTypeLong: "long",
  esriFieldTypeString: "string",
  esriFieldTypeDate: "date",
  esriFieldTypeOID: "oid",
  esriFieldTypeGeometry: "geometry",
  esriFieldTypeBlob: "blob",
  esriFieldTypeRaster: "raster",
  esriFieldTypeGUID: "guid",
  esriFieldTypeGlobalID: "global-id",
  esriFieldTypeXML: "xml"
});
export { i as kebabDict };